import { render, staticRenderFns } from "./ProjectSettingDocumentTemplate.vue?vue&type=template&id=2f2ea0a4&scoped=true"
import script from "./ProjectSettingDocumentTemplate.vue?vue&type=script&lang=js"
export * from "./ProjectSettingDocumentTemplate.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingDocumentTemplate.vue?vue&type=style&index=0&id=2f2ea0a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2ea0a4",
  null
  
)

export default component.exports